import {actionFactory} from '../util/redux-helpers';
import {EndpointURL} from '../constants';
import {fetchWithAuth} from '../util/fetch';

export const ACTIONS = {
  WaitlistTemplatesLoading: 'WAITLIST_TEMPLATES_LOADING',
  WaitlistTemplatesLoaded: 'WAITLIST_TEMPLATES_LOADED',
  WaitlistTemplatesError: 'WAITLIST_TEMPLATES_ERROR',
  WaitlistTemplateAdding: 'WAITLIST_TEMPLATE_ADDING',
  WaitlistTemplateAdded: 'WAITLIST_TEMPLATES_ADDED',
  WaitlistTemplateAddFailed: 'WAITLIST_TEMPLATE_ADD_FAILED',
  WaitlistTemplateUpdating: 'WAITLIST_TEMPLATE_UPDATING',
  WaitlistTemplateUpdated: 'WAITLIST_TEMPLATE_UPDATED',
  WaitlistTemplateUpdateFailed: 'WAITLIST_TEMPLATE_UPDATE_FAILED',
  WaitlistTemplateDeleted: 'WAITLIST_TEMPLATES_DELETED',
  WaitlistTemplateDeleting: 'WAITLIST_TEMPLATES_DELETING',
  WaitlistTemplateDeleteFailed: 'WAITLIST_TEMPLATES_DELETE_FAILED'
};

export const WaitlistTemplatesLoadingInProgress = actionFactory(ACTIONS.WaitlistTemplatesLoading);
export const WaitlistTemplatesLoadingCompleted = actionFactory(ACTIONS.WaitlistTemplatesLoaded);
export const WaitlistTemplatesLoadingFailed = actionFactory(ACTIONS.WaitlistTemplatesError);
export const WaitlistTemplateAdded = actionFactory(ACTIONS.WaitlistTemplateAdded);
export const WaitlistTemplateAdding = actionFactory(ACTIONS.WaitlistTemplateAdding);
export const WaitlistTemplateAddFailed = actionFactory(ACTIONS.WaitlistTemplateAddFailed);
export const WaitlistTemplateUpdated = actionFactory(ACTIONS.WaitlistTemplateUpdated);
export const WaitlistTemplateUpdating = actionFactory(ACTIONS.WaitlistTemplateUpdating);
export const WaitlistTemplateUpdateFailed = actionFactory(ACTIONS.WaitlistTemplateUpdateFailed);
export const WaitlistTemplateDeleting = actionFactory(ACTIONS.WaitlistTemplateDeleting);
export const WaitlistTemplateDeleted = actionFactory(ACTIONS.WaitlistTemplateDeleted);
export const WaitlistTemplateDeleteFailed = actionFactory(ACTIONS.WaitlistTemplateDeleteFailed);

export function LoadWaitlistTemplatesEpic(companyId) {
  return RESTActionEpic(
    `${EndpointURL}admin/waitlist/${companyId}/templates/`,
    WaitlistTemplatesLoadingInProgress,
    WaitlistTemplatesLoadingCompleted,
    WaitlistTemplatesLoadingFailed,
    'GET',
    null
  );
}
export function AddWaitlistTemplateEpic(companyId, template) {
  return RESTActionEpic(
    `${EndpointURL}admin/waitlist/${companyId}/templates`,
    WaitlistTemplateAdding,
    WaitlistTemplateAdded,
    WaitlistTemplateAddFailed,
    'POST',
    template
  );
}
export function UpdateWaitlistTemplateEpic(companyId, template) {
  return RESTActionEpic(
    `${EndpointURL}admin/waitlist/${companyId}/templates/${template._id}`,
    WaitlistTemplateUpdating,
    WaitlistTemplateUpdated,
    WaitlistTemplateUpdateFailed,
    'PUT',
    template
  );
}

export function DeleteWaitlistTemplateEpic(companyId, template) {
  return RESTActionEpic(
    `${EndpointURL}admin/waitlist/${companyId}/templates/${template._id}`,
    WaitlistTemplateDeleting,
    WaitlistTemplateDeleted,
    WaitlistTemplateDeleteFailed,
    'DELETE',
    null
  );
}

export function RESTActionEpic(url, startAction, successAction, failedAction, method, body) {
  return async (dispatch) => {
    try { 
    dispatch(startAction());
    
      let stationResult;
      console.log(body);
      if (method === 'GET') {
        stationResult = await fetchWithAuth(url);
      } else if (method == 'DELETE') {
        stationResult = await fetchWithAuth(url, {
          method: method,
        });
      } else {
        stationResult = await fetchWithAuth(url, {
          method: method,
          body: JSON.stringify(body)
        });
      }
      if (stationResult.status === 200 || stationResult.status === 201){
        dispatch(successAction(await stationResult.json()));
      } else {
        dispatch(failedAction(await stationResult.text()));
      }
    } catch (err) { 
      console.log(err);
      dispatch(failedAction(err));
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/waitlist.actions.js